import { Page, PageProps } from './Page';
import { ViewTabs } from '../ViewTabs';
import {
  COOKIE_POLICY_ROUTE,
  CUSTOMER_SERVICE_ROUTE,
  PRIVACY_POLICY_ROUTE,
  TERMS_OF_SERVICE_ROUTE,
  VERWERKERS_OVEREENKOMST_ROUTE,
} from '../../pages/routes';
import SupportAgentIcon from '@mui/icons-material/SupportAgent';
import GavelIcon from '@mui/icons-material/Gavel';
import AdminPanelSettingsIcon from '@mui/icons-material/AdminPanelSettings';
import ArticleIcon from '@mui/icons-material/Article';
import CookieIcon from '@mui/icons-material/Cookie';

interface InformationPageProps extends PageProps {
  selectedTab: number;
}

export function InformationPage({
  children,
  selectedTab,
  ...props
}: InformationPageProps) {
  return (
    <Page {...props}>
      <ViewTabs
        fixed
        page
        selected={selectedTab}
        tabs={[
          {
            TabComponentProps: { sx: { '&.MuiTab-root': { color: '#fff' } } },
            label: 'Klantenservice',
            slug: CUSTOMER_SERVICE_ROUTE,
            icon: <SupportAgentIcon />,
            component: children,
          },
          {
            TabComponentProps: { sx: { '&.MuiTab-root': { color: '#fff' } } },
            label: 'Algemene voorwaarden',
            slug: TERMS_OF_SERVICE_ROUTE,
            icon: <GavelIcon />,
            component: children,
          },
          {
            TabComponentProps: { sx: { '&.MuiTab-root': { color: '#fff' } } },
            label: 'Privacy voorwaarden',
            slug: PRIVACY_POLICY_ROUTE,
            icon: <AdminPanelSettingsIcon />,
            component: children,
          },
          {
            TabComponentProps: { sx: { '&.MuiTab-root': { color: '#fff' } } },
            label: 'Verwerkersovereenkomst',
            slug: VERWERKERS_OVEREENKOMST_ROUTE,
            icon: <ArticleIcon />,
            component: children,
          },
          {
            TabComponentProps: { sx: { '&.MuiTab-root': { color: '#fff' } } },
            label: 'Cookies',
            slug: COOKIE_POLICY_ROUTE,
            icon: <CookieIcon />,
            component: children,
          },
        ]}
      />
    </Page>
  );
}
